module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_270_DOWN.a5770bc0.png";